import StretchEffect from './StretchEffect';
import { forwardRef } from 'react';

export default forwardRef(function Stretch(props, ref) {
    const effect = new StretchEffect(props);
    return props.active && <primitive object={effect} ref={ref} />;
});
